module.exports = __webpack_public_path__ + "static/media/check.14d38536.svg";